<template>
  <div @click.stop.prevent="onClick">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.2253 12.7604C6.52571 13.0799 7.01276 13.0799 7.31316 12.7604L10.7747 9.07854C11.0751 8.75902 11.0751 8.24098 10.7747 7.92146L7.31316 4.23964C7.01276 3.92012 6.52571 3.92012 6.2253 4.23964C5.9249 4.55916 5.9249 5.0772 6.2253 5.39672L9.14291 8.5L6.2253 11.6033C5.9249 11.9228 5.9249 12.4408 6.2253 12.7604Z"
        fill="currentColor"
      />
    </svg>
  </div>
</template>
<script>
export default {
  name: 'ArrowIcon',
  props: {
    onClick: {
      type: Function,
      default: () => {}
    }
  }
}
</script>
